import { render } from "./ContainersView.vue?vue&type=template&id=06fb0286"
import script from "./ContainersView.vue?vue&type=script&lang=js"
export * from "./ContainersView.vue?vue&type=script&lang=js"

import "./ContainersView.vue?vue&type=style&index=0&id=06fb0286&lang=css"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__